import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default () => ({
  path: "types",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "student-plans" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [],
});
